import styled from 'styled-components';
import { MainPage } from 'Container';

export default styled(MainPage)`
  .form-select.is-invalid {
    border-color: var(--bs-form-invalid-border-color);
  }
`;
